<kendo-tabstrip #tabstrip>
    <kendo-tabstrip-tab title="{{ 'DIRECTORY-SEARCH' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
            <kendo-splitter #splitter orientation="vertical" (layoutChange)="updateSplitterBar()">
                <kendo-splitter-pane [collapsible]="true">
                    <form novalidate [formGroup]="searchForm" class="k-form mb-3" (keydown)="keyDown($event)"
                        style="overflow: hidden;" *ngIf="loaded">
                        <div class="row reduced-search-criteria-margin reduced-custom">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'FIRST-NAME' | translate}}
                                    </span>
                                    <input id="firstName" kendoTextBox formControlName="firstName" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'LAST-NAME' | translate}}
                                    </span>
                                    <input id="lastName" kendoTextBox formControlName="lastName" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'MIDDLE-NAME' | translate}}
                                    </span>
                                    <input id="middleName" kendoTextBox formControlName="middleName" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'GENDER' | translate}}
                                    </span>
                                    <kendo-combobox class="w-100" id="gender" formControlName="gender" [data]="genders"
                                        [textField]="'displayName'" [valueField]="'id'" class="d-flex">
                                    </kendo-combobox>
                                </label>
                            </div>
                        </div>
                        <div class="row reduced-search-criteria-margin reduced-custom">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ORGANIZATION' | translate}}
                                    </span>
                                    <input id="organization" kendoTextBox formControlName="organization"
                                        class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field" *ngIf="allowFacilitySearch">
                                    <span class="k-text-uppercase dark">
                                        {{'FACILITY' | translate}}
                                    </span>
                                    <input id="facility" kendoTextBox formControlName="facility" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'PROVIDER-NPI' | translate}}
                                    </span>
                                    <input id="npi" kendoTextBox formControlName="npi" class="d-flex" />
                                </label>
                            </div>
                        </div>
                        <div class="row reduced-search-criteria-margin reduced-custom">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ADDRESS' | translate}}
                                    </span>
                                    <input id="streetLine" kendoTextBox formControlName="streetLine" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CITY' | translate}}
                                    </span>
                                    <input id="city" kendoTextBox formControlName="city" class="d-flex" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STATE' | translate}}
                                    </span>
                                    <kendo-combobox class="w-100" id="state" formControlName="state" [data]="states"
                                        [textField]="'displayName'" [valueField]="'id'" class="d-flex">
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'POSTAL-CODE' | translate}}
                                    </span>
                                    <input id="postalCode" kendoTextBox formControlName="postalCode" class="d-flex" />
                                </label>
                            </div>
                        </div>
                        <div class="row reduced-search-criteria-margin reduced-custom">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SPECIALTY' | translate}}
                                    </span>
                                    <kendo-combobox [data]="specialtiesFiltered" [textField]="'displayName'"
                                        [valueField]="'displayName'" [filterable]="true"
                                        (filterChange)="filterSpecialties($event)" (close)="searchTerm=''"
                                        [formControl]="specialtyName" [valuePrimitive]="true" [virtual]="virtualLookups"
                                        class="d-flex">
                                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                                            <span title="{{dataItem.displayName}}"
                                                innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <div class="k-text-uppercase dark">
                                        {{'LANGUAGES' | translate}}
                                    </div>
                                    <kendo-multiselect id="languages" [data]="languagesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="languages"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterLanguages($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualLookups"
                                        attr.aria-label="{{'LANGUAGES' | translate}}">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-3">
                                <div class="row ml-0 mt-3" style="padding-top: 20px;">
                                    <button kendoButton type="button" [disabled]="searchDisabled()"
                                        (click)="searchProvider(true)">
                                        {{'SEARCH' | translate}}<i class="far fa-search"></i>
                                    </button>
                                    <i class="fas fa-fw fa-times-circle fa-delete-custom ml-2"
                                        attr.aria-label="{{'SEARCH-CLEAR-ALL' | translate}}" role="button"
                                        title="{{'SEARCH-CLEAR-ALL' | translate}}" [hidden]="searchDisabled()"
                                        (click)="clearSearch()" style="font-size:20pt" tabindex="0"
                                        (keydown.enter)="clearSearch()" (keydown.space)="clearSearch()">
                                    </i>
                                </div>
                            </div>
                        </div>
                    </form>
                </kendo-splitter-pane>
                <kendo-splitter-pane>
                    <!--Search Results-->
                    <kendo-grid #grid [data]="gridView"
                        [pageable]="total > gridState.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                        [pageSize]="gridState.take" [skip]="gridState.skip" [loading]="loading" [sort]="gridState.sort"
                        [filter]="gridState.filter" [sortable]="true" [filterable]="false" [columnMenu]="false"
                        [resizable]="true" [reorderable]="false" [selectedKeys]="keys" [kendoGridSelectBy]="'rowId'"
                        [selectable]="{ mode: (singleSelectionOnly ? 'single' : 'multiple'), checkboxOnly: true }"
                        (dataStateChange)="dataStateChange($event)" (selectedKeysChange)="onSelectedKeysChange($event)"
                        style="margin: 5px;margin-top: 15px;max-height:48vh;">
                        <kendo-grid-checkbox-column [columnMenu]="false" [width]="12" *ngIf="allowSelection"
                            class="text-center">
                        </kendo-grid-checkbox-column>
                        <kendo-grid-messages noRecords="{{ 'NO-PROVIDERS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="fullName" title="{{'NAME' | translate}}" [width]="60">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="ellipsis-text" title="{{getProviderName(dataItem)}}">
                                    {{getProviderName(dataItem)}}
                                </div>
                                <div *ngIf="dataItem.specialtyName" class="ellipsis-text"
                                    title="{{dataItem.specialtyName}}" style="font-size: smaller">
                                    {{dataItem.specialtyName}}
                                </div>
                                <div *ngIf="dataItem.directAddress" class="directAddress montserrat ellipsis-text"
                                    title="{{dataItem.directAddress}}">
                                    <i class="fas fa-copy mr-1" style="font-size: initial; cursor: pointer;"
                                        title="{{'COPY' | translate}}"
                                        (click)="copyDirectAddress(dataItem.directAddress)">
                                    </i>&nbsp;{{dataItem.directAddress}}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="organization" title="{{ 'ORGANIZATION' | translate }}" [width]="50">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div *ngIf="showOrganization(dataItem)" class="ellipsis-text"
                                    title="{{dataItem.organization}}">
                                    {{dataItem.organization}}
                                </div>
                                <div style="font-size: smaller">
                                    <section *ngIf="dataItem.practiceAddress">
                                        <div *ngIf="dataItem.practiceAddress.streetLine">
                                            {{dataItem.practiceAddress.streetLine}}
                                        </div>
                                        <div *ngIf="dataItem.practiceAddress.streetLineAdditional">
                                            {{dataItem.practiceAddress.streetLineAdditional}}
                                        </div>
                                        <div>
                                            <span
                                                *ngIf="dataItem.practiceAddress.city">{{dataItem.practiceAddress.city}}</span>
                                            <span *ngIf="dataItem.practiceAddress.county"><span
                                                    *ngIf="dataItem.practiceAddress.city">,&nbsp;</span>{{dataItem.practiceAddress.county}}</span>
                                            <span *ngIf="dataItem.practiceAddress.state">
                                                <span
                                                    *ngIf="dataItem.practiceAddress.city || dataItem.practiceAddress.county">,&nbsp;</span>{{dataItem.practiceAddress.state}}
                                            </span>
                                            <span
                                                *ngIf="dataItem.practiceAddress.postalCode">{{dataItem.practiceAddress.postalCode}}
                                            </span>
                                            <span
                                                *ngIf="dataItem.practiceAddress.country">{{dataItem.practiceAddress.country}}</span>
                                        </div>
                                    </section>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="{{ 'PHONE' | translate }}" [width]="50" [sortable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="row">
                                    <div class="col-12" *ngIf="dataItem.telephoneNumber"
                                        title="{{'HOME-OR-PRACTICE-PHONE' | translate}}">
                                        <i class="fas fa-phone fa-fw"></i>&nbsp;{{dataItem.telephoneNumber | phone}}
                                        <span *ngIf="dataItem.telephoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX'
                                            |
                                            translate}}&nbsp;{{dataItem.telephoneNumberExtension}}</span>
                                    </div>
                                    <div class="col-12" *ngIf="dataItem.cellPhoneNumber" title="{{'CELL' | translate}}">
                                        <i class="fas fa-mobile-android-alt fa-fw"></i>&nbsp;{{dataItem.cellPhoneNumber
                                        |
                                        phone}}
                                    </div>
                                    <div class="col-12" *ngIf="dataItem.faxNumber" title="{{'FAX' | translate}}">
                                        <i class="fas fa-fax fa-fw"></i>&nbsp;{{dataItem.faxNumber | phone}}
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="allowFacilitySearch" field="facilityName"
                            title="{{ 'FACILITY' | translate }}" [width]="70">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div *ngIf="!dataItem.facilityUrl" class="ellipsis-text"
                                    title="{{dataItem.facilityName}}">
                                    {{dataItem.facilityName}}
                                </div>
                                <a *ngIf="dataItem.facilityUrl" class="ellipsis-text pointer emphasizedLabel"
                                    title="{{dataItem.facilityName}}" (click)="openUrl(dataItem.facilityUrl)">
                                    {{dataItem.facilityName}}
                                </a>
                                <div style="font-size: smaller">
                                    <section *ngIf="dataItem.facilityAddress">
                                        <div *ngIf="dataItem.facilityAddress.streetLine">
                                            {{dataItem.facilityAddress.streetLine}}
                                        </div>
                                        <div *ngIf="dataItem.facilityAddress.streetLineAdditional">
                                            {{dataItem.facilityAddress.streetLineAdditional}}
                                        </div>
                                        <div>
                                            <span
                                                *ngIf="dataItem.facilityAddress.city">{{dataItem.facilityAddress.city}}</span>
                                            <span *ngIf="dataItem.facilityAddress.county"><span
                                                    *ngIf="dataItem.facilityAddress.city">,&nbsp;</span>{{dataItem.facilityAddress.county}}</span>
                                            <span *ngIf="dataItem.facilityAddress.state">
                                                <span
                                                    *ngIf="dataItem.facilityAddress.city || dataItem.facilityAddress.county">,&nbsp;</span>{{dataItem.facilityAddress.state}}
                                            </span>
                                            <span
                                                *ngIf="dataItem.facilityAddress.postalCode">{{dataItem.facilityAddress.postalCode}}
                                            </span>
                                            <span
                                                *ngIf="dataItem.facilityAddress.country">{{dataItem.facilityAddress.country}}</span>
                                        </div>
                                    </section>
                                    <div class="row">
                                        <div class="col-12" *ngIf="dataItem.facilityTelephoneNumber"
                                            title="{{'HOME-OR-PRACTICE-PHONE' | translate}}">
                                            <i class="fas fa-phone fa-fw"></i>&nbsp;{{dataItem.facilityTelephoneNumber |
                                            phone}}
                                            <span
                                                *ngIf="dataItem.facilityTelephoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX'
                                                |
                                                translate}}&nbsp;{{dataItem.facilityTelephoneNumberExtension}}</span>
                                        </div>
                                        <div class="col-12" *ngIf="dataItem.facilityFaxNumber"
                                            title="{{'FAX' | translate}}">
                                            <i class="fas fa-fax fa-fw"></i>&nbsp;{{dataItem.facilityFaxNumber | phone}}
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="languagesName" [width]="55" title="{{ 'LANGUAGES' | translate }}"
                            class="ellipsis-text" [sortable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.languagesName}}">{{dataItem.languagesName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="memberId" field="distance" title="{{ 'DISTANCE' | translate }}"
                            [width]="35">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div *ngIf="dataItem.distance">
                                    <div *ngIf="showMap" class="text-center text-lowercase pointer emphasizedLabel"
                                        (click)="openMap(dataItem);" [title]="showMapTitle">
                                        {{dataItem.distance | number : '1.2-2'}}&nbsp;{{getDistanceDisplayText()}}
                                    </div>
                                    <div *ngIf="!showMap" class="text-center text-lowercase">
                                        {{dataItem.distance | number : '1.2-2'}}&nbsp;{{getDistanceDisplayText()}}
                                    </div>
                                </div>
                                <div class="text-center" *ngIf="!dataItem.distance">{{ 'NA' | translate }}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="qualityScore" class="text-center"
                            title="{{ 'QUALITY-SCORE' | translate }}" [width]="21">
                        </kendo-grid-column>
                    </kendo-grid>
                </kendo-splitter-pane>
            </kendo-splitter>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>